module.exports = __webpack_public_path__ + "images/149_4096.jpg";